import Swiper from '@src/components/swiper';

document.addEventListener('DOMContentLoaded', function (event) {
  const enableSwipers = function () {
    // All swipers we want to move alltogether
    const headerGroup = document.querySelector('.header-group');
    const slidesCount = headerGroup.getAttribute('data');
    const tableSection = document.querySelector('.table-section');
    const tableContainer = tableSection.querySelector('.x-container');
    const swiperBody = new Swiper('.swiper-moving', {
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets'
      },
      navigation: {
        nextEl: tableContainer.classList.contains('three_or_more_cards') || headerGroup.classList.contains('compare-cards') ? '.right-arrow' : '.swiper-button-next',
        prevEl: tableContainer.classList.contains('three_or_more_cards') || headerGroup.classList.contains('compare-cards') ? '.left-arrow' : '.swiper-button-prev'
      },
      // Optional parameters
      direction: 'horizontal',
      loop: true,
      slidesPerView: slidesCount,
      initialSlide: window.location.pathname.indexOf('/payment-methods/card/x-card') >= 0 ? 2 : 0
    });

    const chosenLine = document.querySelectorAll('.swiper-moving');
    // Move all other lines when we go to next slide
    chosenLine.forEach((chosenLine) => {
      chosenLine.swiper.on('slideNextTransitionStart', function () {
        const triggeredSwiper = this;
        // swiper.slideNext(500, false);
        swiperBody.forEach((swiper) => {
          if (swiper !== triggeredSwiper) {
            swiper.slideTo(triggeredSwiper.activeIndex, 500, false);
          }
        });
      });
      // Move all other lines when we go to prev slide
      chosenLine.swiper.on('slidePrevTransitionStart', function () {
        const triggeredSwiper = this;
        // swiper.slidePrev(500, false);
        swiperBody.forEach((swiper) => {
          if (swiper !== triggeredSwiper) {
            swiper.slideTo(triggeredSwiper.activeIndex, 500, false);
          }
        });
      });
    });
  };

  // Destroy swiper (used for Desktop BP)
  const destroySwipers = function () {
    document.querySelectorAll('.swiper-destroy').forEach((el) => {
      const swiper = el.swiper;
      if (swiper) {
        swiper.destroy();
      }
    });
  };

  // Dynamically destroy swiper for Desktop on window resize
  // FIXME - Refacto me by using screenResizerChecker() (utils/screen-resizer-checker.js);
  const breakpoint = window.matchMedia('(min-width:768px)');
  const breakpointCheckerOverview = function () {
    if (breakpoint.matches === true) {
      destroySwipers();
    } else if (breakpoint.matches === false) {
      enableSwipers();
    }
  };

  if (document.querySelector('.header-group')) {
    breakpoint.addListener(breakpointCheckerOverview);
    breakpointCheckerOverview();
  }
});
